/**
 * Build Imgix-powered responsive image URLs for Prismic images.
 * Safe defaults: auto compress/format, quality 70, responsive srcSet, sizes.
 */
const IMG_WIDTHS = [320, 480, 640, 768, 1024, 1280];

function isSvg(url) {
  return /\.svg($|\?)/i.test(url || "");
}

function hasProtocol(url) {
  return /^https?:\/\//i.test(url || "");
}

function addParams(url, params) {
  const u = new URL(url);
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    u.searchParams.set(k, String(v));
  });
  return u.toString();
}

export function buildPrismicImgixSrc(url, opts = {}) {
  if (!url || !hasProtocol(url) || isSvg(url)) {
    return {
      src: url || "",
      srcSet: undefined,
      sizes: undefined,
      placeholder: undefined,
    };
  }

  const {
    maxWidth = 1280,
    quality = 70,
    sizes = "(min-width: 1024px) 1152px, (min-width: 640px) 640px, 100vw",
    dpr = 1,
  } = opts;

  const safeWidths = IMG_WIDTHS.filter((w) => w <= maxWidth);
  const baseParams = { auto: "compress,format", q: quality, fit: "max" };

  const src = addParams(url, {
    ...baseParams,
    w: Math.min(maxWidth, safeWidths[safeWidths.length - 1] || maxWidth),
    dpr,
  });

  const srcSet = safeWidths
    .map((w) => `${addParams(url, { ...baseParams, w, dpr: 1 })} ${w}w`)
    .join(", ");

  // Tiny blurred placeholder
  const placeholder = addParams(url, {
    auto: "compress,format",
    w: 24,
    blur: 200,
    q: 20,
  });

  return { src, srcSet, sizes, placeholder };
}
